import { createContext } from 'react';

export interface NotificationsState {
  /** How many the signed-in account has not read. Zero when nobody is signed in. */
  unread: number;
  /** Ask again — after marking some read, or doing something that makes one. */
  refresh: () => Promise<void>;
}

export const NotificationsContext = createContext<NotificationsState | null>(null);
